import React, {useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'
import {RoleSwitcher} from '../../../../app/platform/auth'
import {useModule} from '../../../../app/platform/modules'
import {DrawerComponent, ScrollComponent, ToggleComponent} from '../../../assets/ts/components'
import {AsideMenuMain} from './AsideMenuMain'
import {ModularAsideMenuMain} from './ModularAsideMenuMain'

type Props = {
  asideMenuCSSClasses: string[]
  hideMenuContent?: boolean
}

const AsideMenu: React.FC<Props> = ({hideMenuContent = false}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const {pathname} = useLocation()
  const {isModuleSession} = useModule()

  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0
      }
    }, 50)
  }, [pathname])

  return (
    <div
      id='kt_aside_menu_wrapper'
      ref={scrollRef}
      className='w-100 hover-scroll-overlay-y d-flex pe-2'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-height='auto'
      data-kt-scroll-dependencies='#kt_aside_logo, #kt_aside_footer'
      data-kt-scroll-wrappers='#kt_aside, #kt_aside_menu, #kt_aside_menu_wrapper'
      data-kt-scroll-offset='100'
    >
      <div
        id='#kt_aside_menu'
        data-kt-menu='true'
        className='menu menu-column menu-rounded fw-bold my-auto'
      >
        {!hideMenuContent && (
          <>
            <div className='menu-item px-5'>
              <div className='menu-content'>
                <RoleSwitcher />
              </div>
            </div>
            {isModuleSession ? <ModularAsideMenuMain /> : <AsideMenuMain />}
          </>
        )}
      </div>
    </div>
  )
}

export {AsideMenu}
